import {escapeHtml} from './components.js';

export const NAV_ITEMS=Object.freeze([
  Object.freeze({id:'home',label:'Home',hash:'#/home',requiresAuth:false}),
  Object.freeze({id:'smokings',label:'Wędzenia',hash:'#/smokings',requiresAuth:true}),
  Object.freeze({id:'recipes',label:'Receptury',hash:'#/recipes',requiresAuth:true,feature:'recipes'}),
  Object.freeze({id:'planner',label:'Planner',hash:'#/planner',requiresAuth:true,feature:'planner'}),
  Object.freeze({id:'dymek',label:'Dymek',hash:'#/dymek',requiresAuth:true,feature:'dymek'}),
  Object.freeze({id:'smokehouse',label:'Moja wędzarnia',hash:'#/smokehouse',requiresAuth:true}),
  Object.freeze({id:'profile',label:'Profil',hash:'#/profile',requiresAuth:false})
]);

export const AUX_ROUTES=Object.freeze([
  Object.freeze({id:'feedback',label:'Zgłoś problem',hash:'#/feedback/bug',requiresAuth:true,feedbackKind:'bug'}),
  Object.freeze({id:'feedback',label:'Mam pomysł',hash:'#/feedback/idea',requiresAuth:true,feedbackKind:'idea'})
]);

const BY_HASH=new Map([...NAV_ITEMS,...AUX_ROUTES].map(item=>[item.hash,item]));

export function normaliseRouteHash(value){
  const raw=String(value||'').trim();
  return BY_HASH.has(raw)?raw:'#/home';
}

export function resolveRoute(hash,{authenticated=false,flags={}}={}){
  const routeHash=normaliseRouteHash(hash);
  const item=BY_HASH.get(routeHash)||NAV_ITEMS[0];
  let status='ready';
  if(item.requiresAuth&&!authenticated)status='auth_required';
  else if(item.feature&&flags?.[item.feature]!==true)status='unavailable';
  return Object.freeze({...item,status});
}

export function navigationMarkup(activeHash,{authenticated=false,flags={}}={}){
  const current=normaliseRouteHash(activeHash);
  const links=NAV_ITEMS.map(item=>{
    const resolved=resolveRoute(item.hash,{authenticated,flags});
    const active=item.hash===current;
    const className=`nav-link${active?' is-active':''}${resolved.status!=='ready'?' is-gated':''}`;
    return `<a class="${className}" href="${escapeHtml(item.hash)}"${active?' aria-current="page"':''} data-route="${escapeHtml(item.id)}"><span>${escapeHtml(item.label)}</span></a>`;
  }).join('');
  return `<nav class="primary-nav" aria-label="Główna nawigacja">${links}</nav>`;
}
